<!--头部信息-->
<!--wj-->
<template>
    <div class="detailTitle">
        <el-row>
            <el-col :span="18">
                 <img src="@/assets/image/qd.png" class="img-detail"><span>中税网通</span>
            </el-col>
            <el-col :span="6" class="col-detail" @click.native="OpenStore()">
                <span class="span-detail">打开</span>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return{

        };
    },
    methods: {
        OpenStore() {
            const that = this;
            location.href='http://url.cn/59TtsAP';
            // if(plus.runtime.isApplicationExist({pname:'cn.wps.moffice_eng',action:'KingsoftOfficeApp://'})){
            //     plus.runtime.openFile(m.fullPath, function(){
            //         that.$toast({message:'打开文件失败，请重试', type: "success",position: "bottom",duration: "2000"});
            //     })
            // }else{
                
            // }
            
        },

    },
};
</script>
<style>
.detailTitle{
    position: fixed;
    z-index: 100;
    width: 100%;
    background: #ffffff;
    box-shadow: 1px 1px 1px #ccc;
}
.img-detail{
    width: 15vw;
    padding: 1rem 0.5rem 1rem 1rem;
    vertical-align: middle;
}
.col-detail{
    text-align: center;
    padding-top: 1.5rem;
}
.span-detail{
    background: #369dfc;
    padding: 0.5rem 1.5rem;
    color: #ffffff;
    border-radius: 2rem;
    vertical-align: -webkit-baseline-middle;
}
</style>


